import { CloseOutlined } from "@ant-design/icons";
import {   Card, Col, Form, Modal, Row } from "antd";
import Input from "antd/es/input/Input";
import React from "react";

interface props {
  onCancel: any;
  isModelOpen: boolean;
}
const BiddingDetailsModal = ({ onCancel, isModelOpen }: props) => {
  const [form] = Form.useForm();

  return (
    <>
      <Modal
        width={1300}
        open={isModelOpen}
        onCancel={() => onCancel(false)}
        closeIcon={false}
        footer={false}
        centered
      >
        <Form form={form}>
          <Card
            size="small"
            title="Bid Details"
            style={{ width: "100%" }}
            type="inner"
            extra={<CloseOutlined onClick={() => onCancel(false)} />}
          >
            <Row gutter={20}>
              <Col sm={12} xs={24} lg={12} xl={12}>
                <Form.Item
                  style={{ margin: "0px 0px 15px 0px" }}

                  // className="inputBoxMb"
                >
                  <Input
                    addonBefore={
                      <span
                        style={{
                          display: "inline-block",
                          width: "150px",
                          textAlign: "left",
                        }}
                      >
                        Product Name
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
              <Col sm={12} xs={24} lg={12} xl={12}>
                <Form.Item style={{ margin: "0px 0px 15px 0px" }}>
                  <Input
                    addonBefore={
                      <span
                        style={{
                          display: "inline-block",
                          width: "150px",
                          textAlign: "left",
                        }}
                      >
                        Req Qty
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={20}>
              <Col sm={12} xs={24} lg={12} xl={12}>
                <Form.Item
                  style={{ margin: "0px 0px 15px 0px" }}

                  // className="inputBoxMb"
                >
                  <Input
                    addonBefore={
                      <span
                        style={{
                          display: "inline-block",
                          width: "150px",
                          textAlign: "left",
                        }}
                      >
                        HSN Codes
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
              <Col sm={12} xs={24} lg={12} xl={12}>
                <Form.Item style={{ margin: "0px 0px 15px 0px" }}>
                  <Input
                    addonBefore={
                      <span
                        style={{
                          display: "inline-block",
                          width: "150px",
                          textAlign: "left",
                        }}
                      >
                        Price
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={20}>
              <Col sm={12} xs={24} lg={12} xl={12}>
                <Form.Item
                  style={{ margin: "0px 0px 15px 0px" }}

                  // className="inputBoxMb"
                >
                  <Input
                    addonBefore={
                      <span
                        style={{
                          display: "inline-block",
                          width: "150px",
                          textAlign: "left",
                        }}
                      >
                        Expected Delivery Date
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
              <Col sm={12} xs={24} lg={12} xl={12}>
                <Form.Item style={{ margin: "0px 0px 15px 0px" }}>
                  <Input
                    addonBefore={
                      <span
                        style={{
                          display: "inline-block",
                          width: "150px",
                          textAlign: "left",
                        }}
                      >
                        Tax Class
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={20}>
              <Col sm={12} xs={24} lg={12} xl={12}>
                <Form.Item
                  style={{ margin: "0px 0px 15px 0px" }}

                  // className="inputBoxMb"
                >
                  <Input
                    addonBefore={
                      <span
                        style={{
                          display: "inline-block",
                          width: "150px",
                          textAlign: "left",
                        }}
                      >
                        Warranty
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
              <Col sm={12} xs={24} lg={12} xl={12}>
                <Form.Item style={{ margin: "0px 0px 15px 0px" }}>
                  <Input
                    addonBefore={
                      <span
                        style={{
                          display: "inline-block",
                          width: "150px",
                          textAlign: "left",
                        }}
                      >
                        Bid Submit Date
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={20}>
              <Col span={24}>
                <Form.Item
                  style={{ margin: "0px 0px 15px 0px" }}

                  // className="inputBoxMb"
                >
                  <Input
                    addonBefore={
                      <span
                        style={{
                          display: "inline-block",
                          width: "150px",
                          textAlign: "left",
                        }}
                      >
                        Other Comments
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Form>
      </Modal>
    </>
  );
};

export default BiddingDetailsModal;
